import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 16,
    maxWidth: 1024,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    textAlign: 'center',
    '& .MuiTypography-body1': {
      fontSize: 16,
    },
  },
  button: {
    marginTop: theme.spacing(4),
  },
}))

const UserLinkedSuccess = () => {
  const classes = useStyles()

  const handleLoginRedirect = () => {
    window.location.href = '/' // Adjust if you want to redirect elsewhere
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3} justifyContent="center" className={classes.content}>
        <Grid item xs={12}>
          <Typography variant="h2" gutterBottom color="primary">
            🎉 Congratulations!
          </Typography>
          <Typography variant="body1">
            Your account was successfully linked to our application.
          </Typography>
          <Typography variant="body1">
            Please, close this tab and login through Okta again.
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}

export default UserLinkedSuccess
